import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    // static targets = ["message"];
    connect() {
        // console.log("flash controller to be loaded" + this.messageTarget);
    }

    close() {
        console.log("close");
        // this.messageTarget.remove();
        this.element.remove();
    }
}